<template>
  <div class="sw-modal confirm-dialog">
    <div v-click-outside="cancelAction" class="sw-modal-content">
      <div class="row sw-modal-heading">
        <div class="col">
          <h4>Add Content</h4>
        </div>
      </div>
      <div class="sw-modal-body">
        <div class="row">
          <div v-on:click.stop="selectType('template')" class="col-4 whatsapp-add-content__type whatsapp-add-content__type--template">
            <div><i class="fas fa-file-alt"></i></div>
            Template
          </div>
          <div v-on:click.stop="selectType('template')" class="col-4 whatsapp-add-content__type whatsapp-add-content__type--location">
            <div><i class="fas fa-map-marker-alt"></i></div>
            Location
          </div>
          <div v-on:click.stop="selectType('template')" class="col-4 whatsapp-add-content__type whatsapp-add-content__type--photo">
            <div><i class="fas fa-images"></i></div>
            Photo
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    // import Vue from 'vue';

    export default {
        name: 'AddContentDialog',
        components: {
        },
        props: {
        },
        data: function() {
            return {
            }
        },
        computed: {
        },
        methods: {
            cancelAction: function() {
                this.$root.$emit("finished-chat-choosing-content-type");
            },
            selectType: function(type) {
                this.$root.$emit("finished-chat-choosing-content-type", type);
            },
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
  @import "../../styles/components/modal.scss";
  @import "../../styles/components/edit_establishment";
  @import "../../styles/pages/whatsapp-add-content";
</style>